module.exports = __webpack_public_path__ + "img/wc_code2.cceb7bc5.png";